import React, { useState, useEffect } from "react";
import * as XLSX from 'xlsx';
import {
  useForm,
  FormProvider
} from "react-hook-form";
import { useHistory } from "react-router-dom";
import { DropzoneDialog } from "material-ui-dropzone";
//Material-UI
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Autocomplete from '@material-ui/lab/Autocomplete';
import LinearProgress from '@material-ui/core/LinearProgress';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Typography from "@material-ui/core/Typography";
import { TextField, Divider } from "@material-ui/core";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//Component
import { BaseContainer } from "../../stories/base-container";
import FormInput from "../../stories/hook-controls/input";
import MuiSelect from "../../stories/hook-controls/select";
import * as alertDialog from "./../../utils/alert";
import { BoxTemplate1 } from "../../stories/Box";
import parse from 'html-react-parser';
//Function
import { isEmptyStr, isEmptyArray, setDataToFormHookV2 } from "../../utils/common-function";
import { ExportForm } from "./api";
import { GetListEncrypt } from "./api";
import { GetColumnsByTableName, GetListTable, GetMessageConsent, GetListSPI, GetMessageSPI,GetListHost } from "./api";
import { GetUser } from "../../utils/sessions";

function DecryptScreen() {
  const methods = useForm();
  const history = useHistory();
  const method = useForm();
  const { register, getValues, setError, clearErrors, errors } = methods;
  const [inputValue, setInputValue] = React.useState('');
  const [listColumn, setListColumn] = useState([]);
  const [listEncryptMap, setListEncryptMap] = useState([]);
  const [listTable, setlistTable] = useState([]);
  const [listSPI, setListSPI] = useState([]);
  const [loading, setLoading] = useState(false);
  const [onGetColumn, setOnGetColumn] = useState(true);
  const [spiType, setSpiType] = useState("");
  const [errorReason, setErrorReason] = useState(false);
  const [spiTypeTEXT, setSpiTypeTEXT] = useState("");
  const [fileType, setFileType] = useState("");
  const [msgConsent, setMessageConsent] = useState("");
  const [listHost, setListHost] = useState([]);
  const [hostKey, setHostKey] = useState('');
  const [autoheightColumnTable,setAutoHeightColumnTable] = useState(true);
  const listFileType = [{ id: "CSV", label: "CSV" }
    , { id: "TEXT", label: "TEXT" }];
  //--------
  useEffect(() => {
    const fetch = async () => {
      let param = { "USER_ID": GetUser() };
      let list = await GetListEncrypt(param);
      setListEncryptMap(list);
    };
    fetch();
    getTableList();
    getHostList();
    getSPIList();
    getMessageConsent();

  }, []);

  const getTableList = async (paramHost) => {
    let param = { "USER_ID": GetUser() ,"HOST_KEY" : paramHost};
    let list = await GetListTable(param);
    setlistTable(list);
  };
  const getHostList = async () => {
    let param = { "USER_ID": GetUser() };
    let list = await GetListHost(param);
    setListHost(list);
  };

  const getSPIList = async () => {
    let param = { "USER_ID": GetUser() };
    let list = await GetListSPI(param);
    setListSPI(list);
  };

  const getMessageConsent = async () => {
    let res = await GetMessageConsent();
    setMessageConsent(res);
  };


  //Event
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...listColumn];
    list[index][name] = value;
    setListColumn(list);
  };

  // Function
  async function GetColumns(event, newInputValue, reason) {
    // console.log(event);
    // console.log(newInputValue);
    // console.log(reason);
    setAutoHeightColumnTable(false);
    setInputValue(newInputValue);
    let chk = listTable.filter((e) => (e.TABLE_SCHEMA + "." + e.TABLE_NAME) === newInputValue)
    //console.log(chk);
    if (chk.length === 0)
      return;
    let param = { TABLE_NAME: newInputValue,HOST_KEY : hostKey };
    let list = await GetColumnsByTableName(param);
    if (!isEmptyArray(list)) {
      const listColumn = list.map((c) => ({
        COLUMN: c.id,
        IS_ENCRYPT: true,
        ENCRYPT_ID: '',
        col: c.col
      }));
      setListColumn(listColumn);
    } else {
      setListColumn([]);
      alertDialog.ErrorDialog("Table Not Found!");
    }

  }

  const CloseScreen = () => {
    history.push("/ExportHistory");
  }

  async function Export() {
    setErrorReason(false);
    clearErrors("UsedSPI");
    clearErrors("HOST_NAME");
    clearErrors("TABLE_NAME");
    clearErrors("fileType");


    console.log(spiType);
    if (isEmptyStr(getValues().REASON)) {
      //alertDialog.ErrorDialog("Please input reason.");
      setErrorReason(true);
      return;
    }
    if (getValues().REASON.length <= 20 || getValues().REASON.length >= 300) {
      setErrorReason(true);
      return;
    }
    if (spiType === "" || spiType === 0) {
      //alertDialog.ErrorDialog("Please select Purpose.");
      setError("UsedSPI", {
        type: "CheckNull",
        message: "Please select Purpose.",
      });
      return;
    }
    if (isEmptyStr(hostKey)) {
      setError("HOST_NAME", {
        type: "CheckNull",
        message: "The Host Name field is required",
      });
      return;
    }
    if (isEmptyStr(inputValue)) {
      setError("TABLE_NAME", {
        type: "CheckNull",
        message: "The Table Name field is required",
      });
      return;
    }
    if (isEmptyStr(fileType.trim())) {
      setError("fileType", { type: "CheckNull", message: "Please Select FileType." });
      return;
    }
    let countDecrypt = 0;
    let columnMap = listColumn.map((item, i) => {
      if (isEmptyStr(item.ENCRYPT_ID.toString())) {
        return {
          COLUMN: item.COLUMN,
          IS_ENCRYPT: false,
          ENCRYPT_ID: NaN,
          COL_INDEX: item.col,
        };
      }
      else {
        countDecrypt++;
        return {
          COLUMN: item.COLUMN,
          IS_ENCRYPT: item.IS_ENCRYPT,
          ENCRYPT_ID: parseInt(item.ENCRYPT_ID),
          COL_INDEX: item.col,
        };
      }
    });
    if (countDecrypt === 0) {
      alertDialog.ErrorDialog("Please select decrypt one or more column.");
      return;
    }

    //console.log(columnMap);

    let form = new FormData();
    let param = { TABLE_NAME: inputValue, FILE_TYPE: fileType, SPI_ID: spiType, REASON: getValues().REASON,HOST_KEY : hostKey };

    form.append("info", JSON.stringify(param));
    form.append("columnMap", JSON.stringify(columnMap));

    if (!loading) {
      setLoading(true);
    }

    let res = await ExportForm(form);
    setLoading(false);

    if (res) {
      history.push("/ExportHistory");
    }
  }
  const handleTypeChange = (event) => {
    //console.log(event.target.value);
    setFileType(event.target.value);
  };

  const handleSPIChange = (event) => {
    setSpiType(event.target.value);
    let getMessageSPI = listSPI.filter((e) => e.id === event.target.value)
    console.log(getMessageSPI[0]);
    if (!isEmptyStr(getMessageSPI[0]?.message)) {
      alertDialog.information(getMessageSPI[0].message);
    }
  };

  const handleHostChange = (event) => {
    //console.log(event.target);
    getTableList(event.target.value);
    setHostKey(event.target.value);
   
  };


  return (

      <BoxTemplate1 AddMargin="0px 25px 0px 25px" height={autoheightColumnTable ? "85vh" : ""} title="Decrypt Table" >
        {console.log(autoheightColumnTable)}
        <FormProvider {...methods}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {/* <div style={{ color: "red" }}>
                {msgConsent != null ? msgConsent : ""}
              </div> */}
              <div>
                {parse(msgConsent)}
              </div>
              <Box display="flex" >
                <TextField
                  id="outlined-full-width"
                  label="Reason"
                  name="REASON"
                  inputRef={register}
                  //style={{ margin: 2 }}
                  fullWidth
                  margin="normal"
                  required
                  variant="outlined"
                  error={errorReason}
                  helperText={errorReason ? "Please input reason 20 - 300 charactor." : ""}
                //defaultValue={userID}

                />
              </Box>
              <br />
              <Box display="flex" >
                <MuiSelect
                  name="UsedSPI"
                  label="Purpose"
                  options={listSPI}
                  errorobj={errors}
                  required
                  onChange={handleSPIChange}
                  value={spiType}
                />
              </Box>
              <br />
            
             <Box display="flex" >
             <MuiSelect
              name="HOST_NAME"
              label="Host Name"
              options={listHost}
              errorobj={errors}
              required
              onChange={handleHostChange}
              value={hostKey}
            />
              </Box>
              <br />
              <Box display="flex" >
                <Autocomplete
                  //freeSolo
                  debug
                  id="combo-box-demo"
                  className="comboIcon"
                  inputValue={inputValue}
                  onInputChange={GetColumns}
                  options={listTable}
                  getOptionLabel={(option) => option.TABLE_SCHEMA + "." + option.TABLE_NAME}
                  style={{ width: '100%' }}
                  renderInput={(params) => <FormInput {...params} name="TABLE_NAME" label="Table Name" errorobj={errors} required />}
                />
              </Box>
              <br />
              <Box display="flex" >
                <MuiSelect
                  name="fileType"
                  label="File Type"
                  options={listFileType}
                  errorobj={errors}
                  required
                  onChange={handleTypeChange}
                  value={fileType}
                />
              </Box>
            </Grid>
            {listColumn.map((x, i) => {
              return (
                <Grid item xs={12} key={"COLUMN_" + i}>
                  <Box className="columnAdd">
                    <Box display="flex" width="100%">
                      <FormInput
                        name={x.COLUMN}
                        variant="filled"
                        label={"Column : " + (i + 1)}
                        value={x.COLUMN}
                        onChange={(e) => handleChange(e, i)}
                      />
                      <MuiSelect
                        name={"ENCRYPT_ID"}
                        label={"Encrypt : " + (i + 1)}
                        options={listEncryptMap}
                        value={x.ENCRYPT_ID}
                        onChange={(e) => handleChange(e, i)}
                      />
                    </Box>
                  </Box>
                </Grid>
              );
            })}
            <Grid item xs={12}>
              {loading && <LinearProgress />}
              {loading && <LinearProgress color="secondary" />}
            </Grid>
            <Grid item xs={12}>
              <Box className="buttonEvent">
                <Button
                  variant="contained"
                  onClick={Export}
                >
                  Export
                </Button>
                <Button variant="contained" onClick={CloseScreen}>
                  Cancel
                </Button>
              </Box>
            </Grid>
          </Grid>
        </FormProvider>
      </BoxTemplate1>
  );
}

export default DecryptScreen;
